import React, { useState, useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import Close from 'assets/svg-icons/SmallClose';
import Warn from 'components/WarnDeleting';
import { parseDate } from 'utils';
import {
  usePlanningActions,
  useAlerts,
  ID,
  FILE_ID,
  FILE_URL,
  FILE_URL_EXPIRES,
  MIMETYPE,
  BUCKET,
  NAME,
  ORIGINAL_NAME,
} from 'store/planning';
import { getOriginName } from '../utils';

import { Container, Preview, ButtonWrap, DeleteBtn, Label } from './styles';

const Item = ({ id, fileData, form, setImagePath, removeMedia }) => {
  const [isShowWarn, setIsShowWarn] = useState();
  const label = useMemo(() => {
    const { lastname, birthday } = form?.patient || {};

    if (!(lastname && birthday)) return getOriginName(fileData[NAME] || fileData[ORIGINAL_NAME]);

    return [lastname, parseDate(birthday)].filter(Boolean).join(' ');
  }, [fileData, form?.patient]);

  const { removeScheduleFormMedia } = usePlanningActions();
  const { action, loading, success, resetAlerts } = useAlerts(removeScheduleFormMedia);
  const handleShowWarn = useCallback(() => setIsShowWarn(($) => !$), []);
  const handleDelete = useCallback(() => {
    if (id) action(id);
  }, [action, id]);

  useEffect(() => {
    if (success) {
      removeMedia(success[ID]);
      resetAlerts();
    }
  }, [fileData, removeMedia, resetAlerts, success]);

  return (
    <Container key={fileData[FILE_ID]}>
      <Preview data={fileData} setImageUrl={setImagePath} />
      {label && <Label>{label}</Label>}
      <ButtonWrap>
        <DeleteBtn type="button" onClick={handleShowWarn}>
          <Close />
        </DeleteBtn>
      </ButtonWrap>
      {isShowWarn && (
        <Warn
          message="Wollen Sie die Datei wirklich löschen?"
          showActon={handleShowWarn}
          deleteAction={handleDelete}
          loading={loading}
          smallWidth
        />
      )}
    </Container>
  );
};

Item.defaultProps = { form: {} };
Item.propTypes = {
  id: PropTypes.string.isRequired,
  fileData: PropTypes.shape({
    [FILE_ID]: PropTypes.string.isRequired,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string.isRequired,
    [MIMETYPE]: PropTypes.string.isRequired,
    [NAME]: PropTypes.string.isRequired,
    [ORIGINAL_NAME]: PropTypes.string.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    patient: PropTypes.shape({
      lastname: PropTypes.string,
      birthday: PropTypes.string,
    }).isRequired,
  }),
  setImagePath: PropTypes.func.isRequired,
  removeMedia: PropTypes.func.isRequired,
};

export default Item;
